import { render, staticRenderFns } from "./MiSoftphone.vue?vue&type=template&id=f743b04e&"
import script from "./MiSoftphone.vue?vue&type=script&lang=js&"
export * from "./MiSoftphone.vue?vue&type=script&lang=js&"
import style0 from "./MiSoftphone.vue?vue&type=style&index=0&id=f743b04e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports